import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { AppSettingsUpdatePayload } from '../../../api/types';
import { updateAppSettings } from '../api/settingsApi';
import { ADMIN_SETTINGS_QUERY_KEY } from './useAppSettings';

export function useUpdateAppSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: AppSettingsUpdatePayload) => updateAppSettings(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_SETTINGS_QUERY_KEY });
    },
  });
}
